import type {ConnectElementConfig} from '../ConnectElementList';

export const CapitalFinancingManualPaymentConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "capitalFinancingManualPayment" */
      '../../../components/Capital/CapitalFinancingManualPayment/CapitalFinancingManualPayment'
    ),
  htmlAttributes: {
    'presentation-mode': {
      isInternal: false,
    },
  },
  htmlEvents: ['onmanualpaymentsubmitted', 'onoverlayclosed'],
  customHtmlElementMethods: {
    setPresentationMode: {
      type: 'AttributeSettingMethod',
      attribute: 'presentation-mode',
      isInternal: false,
      description:
        'Sets the presentation mode. Valid options are "inline" (default) or "overlay".',
    },
    setOnManualPaymentSubmitted: {
      type: 'EventListenerMethod',
      event: 'onmanualpaymentsubmitted',
      isInternal: false,
      description:
        'Sets the event listener for when a manual payment is submitted.',
    },
    setOnOverlayClosed: {
      type: 'EventListenerMethod',
      event: 'onoverlayclosed',
      isInternal: false,
      description:
        'Sets the event listener for when the overlay is closed in overlay mode.',
    },
  },
  releaseState: 'internal',
  sentryTeam: 'capital_for_platforms',
  teamOwner: 'capital-for-platforms',
  description:
    'Allows connected accounts to make manual payments toward active Capital financings.',
  friendlyName: 'Capital Financing Manual Payment',
};
